import { Button, Stack } from '@mui/material';
import { Box } from '@mui/system';
import clsx from 'clsx';
import { ComponentType, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OrganizationsSelect } from '../../organizations';
import useStyles from './styles';

interface SchedulesPanelProps {
  className?: string;
  organization?: any;
  onUpdate: (x: Record<string, any>) => void;
}

export const SchedulesPanel: ComponentType<SchedulesPanelProps> = ({
  className,
  organization: queryOrganization = '',
  onUpdate,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [organization, setOrganization] = useState('');

  const handleSubmit = (e: any) => {
    e.preventDefault();
    onUpdate({ organization });
  };

  useEffect(() => {
    setOrganization(queryOrganization);
  }, [queryOrganization]);

  return (
    <form
      onSubmit={handleSubmit}
      action={'/'}
      method="GET"
      className={clsx(classes.root, className)}
    >
      <Stack direction="row" justifyContent="flex-start" spacing={3} mb={3}>
        <div>
          <OrganizationsSelect
            label={t('organization', 'Организация')}
            placeholder={t('organization', 'Организация')}
            value={organization}
            onChange={(e: any) => setOrganization(e.target.value)}
            size="small"
            sx={{ width: 300 }}
            prompt
            displayEmpty
          />
        </div>
        <Box style={{ paddingTop: 24 }}>
          <Button type="submit" variant="contained" color="secondary">
            {t('action.search', 'Найти')}
          </Button>
        </Box>
      </Stack>
    </form>
  );
};
